"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MoreMenu = void 0;
const lit_1 = require("lit");
const decorators_js_1 = require("lit/decorators.js");
const if_defined_js_1 = require("lit/directives/if-defined.js");
const repeat_js_1 = require("lit/directives/repeat.js");
require("@/components/common");
require("@/components/overlay/popover/popover");
require("@/components/overlay/sheet");
const adaptive_overlay_controller_1 = require("@/controllers/adaptive-overlay-controller");
const utils_1 = require("@/utils");
/**
 * 더보기 버튼으로 여는 명령 목록. 값을 고르는 mm-select와 달리 선택 상태를 남기지 않고, 누른 명령만 알린다.
 * 좁은 화면에서는 mm-select처럼 목록을 sheet로 올린다. 두 표면은 portal로 옮겨져 slot으로 받은 항목을
 * 투영할 수 없으므로, 항목은 actions 배열로 받아 어느 표면이든 직접 렌더한다.
 */
let MoreMenu = class MoreMenu extends lit_1.LitElement {
    constructor() {
        super(...arguments);
        this.actions = [];
        this.placement = 'bottom-end';
        this.ariaLabel = '더보기';
        this.overlay = new adaptive_overlay_controller_1.AdaptiveOverlayController(this);
    }
    render() {
        return (0, lit_1.html) `
      ${this.renderTrigger()} ${this.renderPopover()} ${this.renderSheet()}
    `;
    }
    // popover·sheet는 portal로 옮겨져 조건부로 걷어낼 수 없으므로 늘 마운트해 두고 목록만 넣고 뺀다.
    renderPopover() {
        return (0, lit_1.html) `
      <mm-popover
        placement=${this.placement}
        .anchor=${this.overlay.trigger}
        ?open=${!this.overlay.compact && this.overlay.open}
        @toggle=${this.overlay.handleOverlayToggle}
      >
        ${this.overlay.compact ? lit_1.nothing : this.renderActionList()}
      </mm-popover>
    `;
    }
    renderSheet() {
        return (0, lit_1.html) `
      <mm-sheet
        aria-label=${this.ariaLabel}
        ?open=${this.overlay.compact && this.overlay.open}
        @toggle=${this.overlay.handleOverlayToggle}
      >
        <mm-sheet-header heading=${this.ariaLabel}></mm-sheet-header>
        <mm-sheet-body>${this.overlay.compact ? this.renderActionList() : lit_1.nothing}</mm-sheet-body>
      </mm-sheet>
    `;
    }
    // 열림 상태를 AdaptiveOverlayController가 소유하므로 aria-controls를 걸지 않고(걸면 표면이 같은 클릭을 또 토글한다),
    // 더보기 메뉴가 클릭과 aria-expanded를 직접 배선한다.
    renderTrigger() {
        return (0, lit_1.html) `
      <mm-more-button
        aria-label=${this.ariaLabel}
        aria-haspopup=${this.overlay.compact ? 'dialog' : 'menu'}
        aria-expanded=${this.overlay.open ? 'true' : 'false'}
        @click=${this.overlay.handleTriggerClick}
      ></mm-more-button>
    `;
    }
    renderActionList() {
        return (0, lit_1.html) `
      <mm-menu-item-group aria-label=${this.ariaLabel}>
        ${(0, repeat_js_1.repeat)(this.actions, action => action.value, action => this.renderAction(action))}
      </mm-menu-item-group>
    `;
    }
    renderAction(action) {
        return (0, lit_1.html) `
      <mm-menu-item-action
        label=${action.label}
        icon=${(0, if_defined_js_1.ifDefined)(action.icon)}
        tone=${action.tone ?? ''}
        ?disabled=${action.disabled}
        @click=${() => this.handleActionClick(action)}
      ></mm-menu-item-action>
    `;
    }
    // 명령을 누르면 목록을 닫고 항목의 onClick을 실행한 뒤 어떤 명령인지 알린다.
    handleActionClick(action) {
        if (action.disabled)
            return;
        this.overlay.close();
        action.onClick?.();
        (0, utils_1.emit)(this, 'action', { value: action.value });
    }
};
MoreMenu.styles = (0, lit_1.css) `
    :host {
      display: inline-flex;
    }
  `;
__decorate([
    (0, decorators_js_1.property)({ attribute: false })
], MoreMenu.prototype, "actions", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String })
], MoreMenu.prototype, "placement", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String, attribute: 'aria-label' })
], MoreMenu.prototype, "ariaLabel", void 0);
MoreMenu = __decorate([
    (0, decorators_js_1.customElement)('mm-more-menu')
], MoreMenu);
exports.MoreMenu = MoreMenu;
//# sourceMappingURL=data:application/json;base64,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